import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import vuetify from "./plugins/vuetify";
import VueGeolocation from 'vue-browser-geolocation'
import * as  VueGoogleMaps from 'vue2-google-maps'
import "@/assets/styles/fontawesome.min.css";
import "@/assets/styles/vuetify.css";
import "@/assets/styles/all.min.css";
import "@/assets/styles/bootstrap.min.css";
import moment from "moment-jalaali";
import goTo from 'vuetify/lib/services/goto';
import VuePreferences, {preference} from 'vue-preferences'
import VuePageTransition from 'vue-page-transition'
import VueAddtohomescreen from "@owliehq/vue-addtohomescreen";
import VueSilentbox from 'vue-silentbox';
import VueMeta from 'vue-meta';

Vue.use(VueSilentbox)
Vue.use(VuePageTransition)
Vue.use(VuePreferences, {
    storage: window.localStorage,
    namespace: 'izisys'
});

Vue.prototype.$BaseUrl = "https://izisys.aslanianmachine.com/"

Vue.prototype.$faJson = null;

Vue.prototype.$enJson = null;


Vue.use(VueMeta);

Vue.prototype.$setCssFiles = function () {
    if (this.$getLanguage() === "en") {
        if (this.$getUserSeason() === "Autumn") {
            import("@/assets/styles/masterFallEnglish.css")
        } else if (this.$getUserSeason() === "Winter") {
            import("@/assets/styles/masterwinterEnglish.css")
        } else if (this.$getUserSeason() === "Spring") {
            import("@/assets/styles/masterSpringEnglish.css")
        } else if (this.$getUserSeason() === "Summer") {
            import("@/assets/styles/masterSummerEnglish.css")
        }


    }
    // Farsi
    else if (this.$getUserSeason() === "Autumn") {
        import("@/assets/styles/masterFallFarsi.css")
    } else if (this.$getUserSeason() === "Winter") {
        import("@/assets/styles/masterwinterFarsi.css")
    } else if (this.$getUserSeason() === "Spring") {
        import("@/assets/styles/masterSpringFarsi.css")
    } else if (this.$getUserSeason() === "Summer") {
        import("@/assets/styles/masterSummerFarsi.css")
    }
}


Vue.prototype.$setUserSeason = function (Season) {
    preference('Season', {defaultValue: ''}).set(Season);
}
Vue.prototype.$getUserSeason = function () {
    return preference('Season', {defaultValue: ''}).get();
}

Vue.prototype.$currentseasen = function (month) {
    if (3 <= month && month <= 5) {
        return 'Spring';
    }

    if (6 <= month && month <= 8) {
        return 'Summer';
    }

    if (9 <= month && month <= 11) {
        return 'Autumn';
    }

    // Months 12, 01, 02
    return 'Winter';
}

Vue.prototype.$getbannerwinter = function () {

    if (this.$getLanguage() === "en") {
        return require("./assets/json/bannerwinteren.json");
    }
    return require("./assets/json/bannerwinterfa.json");
}
Vue.prototype.$getbannerfall = function () {

    if (this.$getLanguage() === "en") {
        return require("./assets/json/bannerfallen.json");
    }
    return require("./assets/json/bannerfallfa.json");
}
Vue.prototype.$getbannerspring = function () {

    if (this.$getLanguage() === "en") {
        return require("./assets/json/bannerspringen.json");
    }
    return require("./assets/json/bannerspringfa.json");
}
Vue.prototype.$getbannersummer = function () {

    if (this.$getLanguage() === "en") {
        return require("./assets/json/bannersummeren.json");
    }
    return require("./assets/json/bannersummerfa.json");
}

Vue.prototype.$getimageSeason = function () {

    if (this.$getLanguage() === "en") {
        return require("./assets/json/imageSeasonfa.json");
    }
    return require("./assets/json/imageSeasonfa.json");
}

Vue.prototype.$setLanguage = function (language) {
    preference('locale', {defaultValue: 'fa'}).set(language);
}

Vue.prototype.$getLanguage = function () {
    let lang = preference('locale', {defaultValue: 'fa'}).get();

    if (lang === "undefined") {
        return "fa"
    }
    return lang;
}

Vue.prototype.$changeRTL = function () {
    if (this.$getLanguage() === "fa")
        this.$vuetify.rtl = true

    else {
        this.$vuetify.ltr = true
    }
}

Vue.prototype.$getText = function (constant) {
    if (this.$faJson === null) {
        this.$faJson = require("./assets/json/langfa.json");
    }

    if (this.$enJson === null) {
        this.$enJson = require("./assets/json/langen.json");
    }

    if (this.$getLanguage() === "en") {
        return this.$enJson[constant];
    }
    return this.$faJson[constant];
}

Vue.prototype.$getAllProjects = function () {
    if (this.$getLanguage() === "en") {
        return require("./assets/json/projectsen.json");

    } else {
        return require("./assets/json/projectsfa.json");

    }
}

Vue.prototype.$getServices = function () {
    if (this.$getLanguage() === "en") {
        return require("./assets/json/servicesen.json");
    }
    return require("./assets/json/servicesfa.json");
}

Vue.prototype.$getBenefits = function () {
    if (this.$getLanguage() === "en") {
        return require("./assets/json/benefitsen.json");
    }
    return require("./assets/json/benefitsfa.json");
}

Vue.prototype.$getimageSeason = function () {
    if (this.$getLanguage() === "en") {
        return require("./assets/json/imageSeasonen.json");
    }
    return require("./assets/json/imageSeasonfa.json");
}

Vue.prototype.$getexpansion = function () {
    if (this.$getLanguage() === "en") {
        return require("./assets/json/expansionen.json");
    }
    return require("./assets/json/expansionfa.json");
}

Vue.prototype.$getcardslide = function () {
    if (this.$getLanguage() === "en") {
        return require("./assets/json/cardslideen.json");
    }
    return require("./assets/json/cardslidefa.json");
}

Vue.prototype.$getnavItems = function () {
    if (this.$getLanguage() === "en") {
        return require("./assets/json/navItemsen.json");
    }
    return require("./assets/json/navItemsfa.json");
}

Vue.prototype.$getisokia = function () {
    if (this.$getLanguage() === "en") {
        return require("./assets/json/isokiaen.json");
    }
    return require("./assets/json/isokiafa.json");
}

Vue.prototype.$getfooter = function () {
    if (this.$getLanguage() === "en") {
        return require("./assets/json/footeren.json");
    }
    return require("./assets/json/footerfa.json");
}

Vue.prototype.$scrollTop = function (x) {
    return goTo(x);
}

Vue.use(VueAddtohomescreen);

Vue.prototype.$setUserData = function (mobile, activeCode, token, role) {
    preference('userData', {defaultValue: '{"mobile":"", "activeCode":"","token":"","role":""}'})
        .set(JSON.stringify({'mobile': mobile, 'activeCode': activeCode, 'token': token, 'role': role}));
};

Vue.prototype.$getUserData = function () {
    return JSON.parse(preference('userData',
        {defaultValue: '{"mobile":"", "activeCode":"","token":"","role":""}'}).get());
};

Vue.prototype.$moment = function (date) {
    return moment(date).format('jYYYY/jM/jD');
};

Vue.config.productionTip = false;

Vue.prototype.$baseUrl = "https://";
Vue.prototype.$replaceHttps = function (httpUrl) {
    if (httpUrl !== null) {
        return httpUrl.replace('http://', 'https://');
    }
};

Vue.prototype.$computingPriceOffer = function (price, off) {
    let priceNum = price;

    if (typeof priceNum !== "number") {
        priceNum = price.replace(",", "");
    }
    return this.$numberWithCommas(parseInt(priceNum) - (parseInt(priceNum) * (off / 100))) + ' تومان';
};

Vue.prototype.$numberWithCommas = function (x) {
    if (x !== null) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
};

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCDfnJg1u4elSPk5-bFPHlKvF62D3YdgtU',
        libraries: '',
        language: 'fa'
    }
});

Vue.use(VueGeolocation)
new Vue({
    router,

    vuetify,
    render: (h) => h(App),
}).$mount("#app");


Vue.config.productionTip = false


new Vue({
    router,
    vuetify,
    render: h => h(App)
}).$mount('#app')

Vue.prototype.$scrollTop = function (x) {
    return goTo(x);
}
Vue.prototype.$convertDate = function (date) {
    let sliceDate = date.slice(0, 10)
    return moment(sliceDate).format('jYYYY/jMM/jDD')
}


Vue.prototype.$convertDate = function (date) {
    let sliceDate = date.slice(0, 10)
    return moment(sliceDate).format('jYYYY/jM/jD')
}
Vue.prototype.$computingPriceOffer = function (price, off) {
    let priceNum = price;

    if (typeof priceNum !== "number") {
        priceNum = price.replace(",", "");
    }
    return this.$numberWithCommas(parseInt(priceNum) - (parseInt(priceNum) * (off / 100)));
};
Vue.prototype.$numberWithCommas = function (x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

Vue.prototype.$replaceHttps = function (httpUrl) {
    if (httpUrl === null) {
        return null;
    }
    return httpUrl.replace('http://', 'https://');
};

Vue.prototype.$productInfoArray = []

Vue.prototype.$global = {};


new Vue({
    router,
    vuetify,
    render: h => h(App)
}).$mount('#app')
